import { useMount } from 'shared/src/hooks';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

type Params = {
  from: string | undefined;
  birth: string | null;
};

export const useLogViewEvent = ({ from, birth }: Params) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({
      name: 'VIEW_MY_INFO',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        FROM: from ?? null,
        BIRTH: birth,
      },
    });
  });
};
